import _ from 'lodash';
import { fromJsonArray } from 'src/core/utils';
import Video from 'src/entities/video/Video';
import VideoCategory from 'src/entities/video/VideoCategory';
import VideoLanguage from 'src/entities/video/VideoLanguage';
import VideoTopic from 'src/entities/video/VideoTopic';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

/* Video Topics */
export const getVideoTopics = (state: any): EntityCollectionState<VideoTopic> => {
    const data = state.videoTopics;

    if (_.isEmpty(data)) return entityCollectionDefaultState<VideoTopic>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(VideoTopic, data.items).sort((a, b) => a.sortOrder - b.sortOrder),
    };
};

/* Video Categories */
export const getVideoCategories = (state: any): EntityCollectionState<VideoCategory> => {
    const data = state.videoCategories;

    if (_.isEmpty(data)) return entityCollectionDefaultState<VideoCategory>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(VideoCategory, data.items).sort((a, b) => a.sortOrder - b.sortOrder),
    };
};

/* Video Languages */
export const getVideoLanguages = (state: any): EntityCollectionState<VideoLanguage> => {
    const data = state.videoLanguages;

    if (_.isEmpty(data)) return entityCollectionDefaultState<VideoLanguage>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(VideoLanguage, data.items),
    };
};

/* Next Video */
export const getNextVideo = (state: any): SingleEntityState<Video> => {
    const data = state.nextVideo;

    if (_.isEmpty(data)) return singleEntityDefaultState<Video>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new Video(data.content) : undefined,
    };
};
